import React from 'react';
import { getHoursAndMinutesFromMinutes } from '../../../Domain/Utils/TimeUtilities/TimeUtilities';

const HoursAndMinutes = ({ parameters = {}, duration = 0 }) => {
  const { hours, minutes } = getHoursAndMinutesFromMinutes(duration);

  const HoursLabel =
    hours > 0 ? `${hours} ${parameters['HOUR'.concat(hours > 1 ? 'S' : '')]?.value}` : '';

  const MinutesLabel =
    minutes > 0 ? `${minutes} ${parameters['MINUTE'.concat(minutes > 1 ? 'S' : '')]?.value}` : '';

  return <>{`${HoursLabel} ${MinutesLabel}`}</>;
};

export default HoursAndMinutes;
